import React from 'react';

function Step2({ 
  formData, 
  errors, 
  onChange, 
  departamentos = [], 
  municipiosNacimiento = [], 
  municipiosExpedicion = [], 
  municipiosResidencia = [] 
}) {   
  return (
    <div className="step-panel">

      {/* --- SECCIÓN NACIMIENTO --- */}
      <div className="field-group">
        <label htmlFor="departamentoNacimiento">
          Departamento de Nacimiento <span className="required">*</span>
        </label>
        <select
          id="departamentoNacimiento"
          name="departamentoNacimiento"
          value={formData.departamentoNacimiento || ''}
          onChange={onChange}
          className={errors.departamentoNacimiento ? 'error-field' : ''}
        >
          <option value="">Seleccione un departamento...</option>
          {departamentos.map(dep => (
            <option key={String(dep.id)} value={dep.nombre}>
              {dep.nombre}
            </option>
          ))}
        </select>
        {errors.departamentoNacimiento && <span className="field-error">{errors.departamentoNacimiento}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="municipioNacimiento">
          Municipio de Nacimiento <span className="required">*</span>
        </label>
        <select
          id="municipioNacimiento"
          name="municipioNacimiento"
          value={formData.municipioNacimiento || ''}
          onChange={onChange}
          disabled={!formData.departamentoNacimiento}
          className={errors.municipioNacimiento ? 'error-field' : ''}
        >
          <option value="">
            {!formData.departamentoNacimiento 
              ? "Seleccione primero un departamento..." 
              : "Seleccione un municipio..."}
          </option>
          {municipiosNacimiento.map((municipio) => (
            <option key={String(municipio.id || municipio.id_municipio || municipio.idMunicipio)} value={municipio.nombre}>
              {municipio.nombre}
            </option>
          ))}
        </select>
        {errors.municipioNacimiento && <span className="field-error">{errors.municipioNacimiento}</span>}
      </div>

      {/* --- SECCIÓN EXPEDICIÓN --- */}
      <div className="field-group">
        <label htmlFor="fechaExpedicion">
          Fecha de Expedición del Documento <span className="required">*</span>
        </label>
        <input
          id="fechaExpedicion"
          name="fechaExpedicion"
          type="date"
          value={formData.fechaExpedicion || ''}
          onChange={onChange}
          className={errors.fechaExpedicion ? 'error-field' : ''}
        />
        {errors.fechaExpedicion && <span className="field-error">{errors.fechaExpedicion}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="departamentoExpedicion">
          Departamento de Expedición del Documento <span className="required">*</span>
        </label>
        <select
          id="departamentoExpedicion"
          name="departamentoExpedicion"
          value={formData.departamentoExpedicion || ''}
          onChange={onChange}
          className={errors.departamentoExpedicion ? 'error-field' : ''}
        >
          <option value="">Seleccione...</option>
          {departamentos.map(dep => (
            <option key={String(dep.id)} value={dep.nombre}>
              {dep.nombre}
            </option>
          ))}
        </select>
        {errors.departamentoExpedicion && <span className="field-error">{errors.departamentoExpedicion}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="municipioExpedicion">
          Municipio de Expedición del Documento <span className="required">*</span>
        </label>
        <select
          id="municipioExpedicion"
          name="municipioExpedicion"
          value={formData.municipioExpedicion || ''}
          onChange={onChange}
          disabled={!formData.departamentoExpedicion}
          className={errors.municipioExpedicion ? 'error-field' : ''}
        >
          <option value="">
            {!formData.departamentoExpedicion 
              ? "Seleccione primero un departamento..." 
              : "Seleccione un municipio..."}
          </option>
          {municipiosExpedicion.map((municipio) => (
            <option key={String(municipio.id || municipio.id_municipio || municipio.idMunicipio)} value={municipio.nombre}>
              {municipio.nombre}
            </option>
          ))}
        </select>
        {errors.municipioExpedicion && <span className="field-error">{errors.municipioExpedicion}</span>}
      </div>

      {/* --- SECCIÓN RESIDENCIA --- */}
      <div className="field-group">
        <label htmlFor="departamentoResidencia">
          Departamento de Residencia <span className="required">*</span>
        </label>
        <select
          id="departamentoResidencia"
          name="departamentoResidencia"
          value={formData.departamentoResidencia || ''}
          onChange={onChange}
          className={errors.departamentoResidencia ? 'error-field' : ''}
        >
          <option value="">Seleccione un departamento...</option>
          {departamentos.map(dep => (
            <option key={String(dep.id)} value={dep.nombre}>
              {dep.nombre}
            </option>
          ))}
        </select>
        {errors.departamentoResidencia && <span className="field-error">{errors.departamentoResidencia}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="municipioResidencia">
          Municipio de Residencia <span className="required">*</span>
        </label>
        <select
          id="municipioResidencia"
          name="municipioResidencia"
          value={formData.municipioResidencia || ''}
          onChange={onChange}
          disabled={!formData.departamentoResidencia}
          className={errors.municipioResidencia ? 'error-field' : ''}
        >
          <option value="">
            {!formData.departamentoResidencia 
              ? "Seleccione primero un departamento..." 
              : "Seleccione un municipio..."}
          </option>
          {municipiosResidencia.map((municipio) => (
            <option key={String(municipio.id || municipio.id_municipio || municipio.idMunicipio)} value={municipio.nombre}>
              {municipio.nombre}
            </option>
          ))}
        </select>
        {errors.municipioResidencia && <span className="field-error">{errors.municipioResidencia}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="barrioResidencia">
          Barrio de Residencia <span className="required">*</span>
        </label>
        <input
          id="barrioResidencia"
          name="barrioResidencia"
          type="text"
          value={formData.barrioResidencia || ''}
          onChange={onChange}
          placeholder="Ingrese el barrio de residencia"
          className={errors.barrioResidencia ? 'error-field' : ''}
        />
        {errors.barrioResidencia && <span className="field-error">{errors.barrioResidencia}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="direccionResidencia">
          Dirección de Residencia <span className="required">*</span>
        </label>
        <input
          id="direccionResidencia"
          name="direccionResidencia"
          type="text"
          value={formData.direccionResidencia || ''}
          onChange={onChange}
          placeholder="Ingrese su dirección"
          className={errors.direccionResidencia ? 'error-field' : ''}
        />
        {errors.direccionResidencia && <span className="field-error">{errors.direccionResidencia}</span>}
      </div>
    </div>
  );
}

export default Step2;